// src/utils/auth.js
// token存储在localStorage中的键名
const TokenKey = 'Admin-Token'

// 获取token
export function getToken() {
  return localStorage.getItem(TokenKey)
}

// 设置token
export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

// 移除token
export function removeToken() {
  return localStorage.removeItem(TokenKey)
} 